document.addEventListener('DOMContentLoaded', () => {
    const body = document.querySelector('body');

    if (localStorage.getItem('taxState') === 'tax-off') {
        body.classList.remove('tax-on');
        body.classList.add('tax-off');
    } else {
        body.classList.remove('tax-off');
        body.classList.add('tax-on');
    }

    body.querySelector('.tax-switch-link').addEventListener('click', () => {
        body.classList.toggle('tax-off');
        body.classList.toggle('tax-on');

        if (body.classList.contains('tax-on')) {
            body.classList.remove('tax-off');
        } else {
            body.classList.remove('tax-on');
        }

        localStorage.setItem('taxState', body.classList.contains('tax-on') ? 'tax-on' : 'tax-off');
    });
});